/* eslint-disable @typescript-eslint/consistent-type-imports */
import { AutoMap } from '@automapper/classes';
import type { DocumentId, DocumentRevision } from '../../types';

export class GenericModel {
  @AutoMap(() => String)
  _id: DocumentId;

  @AutoMap(() => Number)
  _rev: DocumentRevision;

  @AutoMap(() => String)
  createdBy: DocumentId;

  @AutoMap(() => String)
  updatedAt: string;

  @AutoMap(() => String)
  createdAt: string;

  @AutoMap()
  schemaVersion: number;
}
